import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import BlogItem from "../../components/blogPageComponents/BlogItem";
import SlideTransition from "../../components/SlideTransition";

import { useInView } from "../../hooks/useInView";

import { content } from "../../utils/content";
import { BLOG_LANGUAGE_OPTIONS } from "../../utils/optionUtils";

const BlogPage = () => {
  const [setRef, visible] = useInView({
    threshold: 0.1,
  });
  const { t } = useTranslation();

  const [tabValue, setTabValue] = useState(
    BLOG_LANGUAGE_OPTIONS.values().next().value.VALUE
  );

  const handleScrollToItem = (id) => () => {
    document.querySelector(`#${id}`)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div
      className="flex items-start justify-center min-h-[100vh] relative w-full"
      ref={setRef}
    >
      <div className="flex flex-col items-center justify-center max-w-screen-xl px-3 py-4 space-y-8 w-full xl:px-0 xl:py-12 xl:space-y-20">
        <div className="flex flex-col justify-start space-y-2 w-full">
          <SlideTransition appear={visible} timeout={400}>
            <h1 className="capitalize font-bold leading-snug text-4xl  text-secondary tracking-wide sm:leading-normal sm:text-6xl">
              {t(content.blog.header)}
            </h1>
          </SlideTransition>

          <SlideTransition appear={visible} timeout={400}>
            <p className="font-normal leading-normal px-1 text-gray-600 text-sm tracking-wide sm:text-base">
              {t(content.blog.subheader)}
            </p>
          </SlideTransition>
        </div>

        <div className="flex flex-col-reverse gap-12 w-full xl:flex-row xl:gap-16">
          <SlideTransition appear={visible} className="xl:w-4/5" timeout={600}>
            <div className="flex flex-col flex-wrap h-fit space-y-9 xl:flex-row  xl:space-y-12 ">
              {content?.blog?.items && content?.blog?.items?.length ? (
                content?.blog?.items.map((item, idx) => {
                  return (
                    <div id={item.id} key={idx}>
                      <BlogItem data={item} index={idx} visible={true} />
                    </div>
                  );
                })
              ) : (
                <div className="flex items-center px-1 py-20 text-gray-500 text-sm">
                  {t(content.blog.null)}
                </div>
              )}
            </div>
          </SlideTransition>

          {content?.blog?.items && content?.blog?.items?.length && (
            <div className="bg-gray-50 flex flex-col h-fit overflow-hidden px-4 xl:px-10 py-8 xl:py-8 relative space-y-5 xl:sticky xl:top-20">
              <p className="font-semibold text-secondary text-xl">
                {t("Recent Blogs")}
              </p>

              <div className="flex flex-col space-y-4">
                {content?.blog?.items.slice(0, 5).map((item, index) => {
                  return (
                    <div
                      className="flex items-center px-3 space-x-3 w-full"
                      key={index}
                    >
                      <div className="bg-primary h-1 min-w-1" />

                      <p
                        onClick={handleScrollToItem(item.id)}
                        className="cursor-pointer font-normal line-clamp-1 text-gray-900 text-sm hover:underline"
                      >
                        {item.title}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
